<template>
  <div class="introductionList">
    <heads></heads>
    <banners :pic="'pic2'"></banners>
    <div class="container">
      <div class="content">
        <div class="search-wrapper">
          <div class="search-input-wrapper">
            <input type="text" class="search-input" placeholder="请输入您想查找的内容" v-model="title" />
            <div class="search-btn" @click="tosearch">
              <span class="el-icon-search"></span>
              搜索
            </div>
          </div>
        </div>
        <div class="textnav">
          <span
            v-for="(item,index) in textArray"
            :key="index"
            :class="index== activeIndex ?'nac-active':''"
            @click="getText(index)"
          >{{item}}</span>
        </div>
        <div class="list">
          <div class="useractivity" v-loading="loading">
            <div
              class="useritem"
              v-for="(item,index) in pageArray"
              :key="index"
              @click="$router.push({ path: `/introductionDetail`,query:{id:item.id} })"
            >
              <div class="img">
                <img :src="item.coverMap" class="act-img" />
              </div>
              <div class="user-right">
                <div class="act-title">{{item.title}}</div>
                <div class="userdescribe" v-html="item.summary"></div>
                <div class="bottom-infos">
                  <div>
                    <!-- <span class="icon-one">
                      <i class="fa fa-eye" aria-hidden="true"></i> 1265
                    </span>-->
                    <span class="icon-two">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      {{fomateDate(item.createDate)}}
                    </span>
                  </div>
                  <span class="mores">
                    查看更多
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNumber"
                :page-size="10"
                :total="total"
              ></el-pagination>
            </div> -->
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNumber"
            :page-size="10"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";

import axios from "axios";
export default {
  name: "introductionList",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      textArray: ["游记", "攻略"],
      activeIndex: 0,
      title: "",
      subjectId: 54,
      pageArray: [],
      total: 0,

      loading:false
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    fomateDate,
  
    handleCurrentChange(val) {
      this.loading = true;
      this.getArticlePage();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getArticlePage() {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: 5,
        subjectId: this.subjectId,
        title: this.title
      };

      axios
        .get(`/mobile/cmsArticle/getArticlePage.jhtml`, {
          params
        })
        .then(res => {
          if (res.data.success) {
            this.pageArray = res.data.output.list;
            this.total = res.data.output.total;
            this.loading = false;
          }
        });
    },
    tosearch() {
      this.loading = true;
      this.getArticlePage();
    },
    getText(index) {
      this.activeIndex = index;
      if (this.activeIndex == 0) {
        this.subjectId = 54;
        this.pageArray = [];
        this.pageNumber = 1;

        // this.getArticlePage();
      } else {
        this.subjectId = 37;
        this.pageArray = [];
        this.pageNumber = 1;

        // this.getArticlePage();
      }
      this.loading = true;
      this.getArticlePage();
    }
  },
  mounted() {},
  created() {
    this.loading = true;
    this.getArticlePage();
  }
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
}
.content {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
}
.list {
  cursor: pointer;
  width: 100%;
  padding: 20px;
  /* box-shadow: 0px 0px 6px #c7c6c6;
      border-radius: 2px; */
  margin-bottom: 20px;

  /* min-height: 350px; */
}

.evaluate {
  display: flex;
}
.evaluate > span {
  font-size: 15px;
  width: 80px;
  color: #666666;
  line-height: 20px;
}
.evaluate > span:nth-child(2) {
  text-align: right;
  border-left: 1px solid #999999;
}

.useractivity {
  width: 100%;

  min-height: 350px;
}
.useritem {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin-bottom: 16px;
}
.useritem:hover{
  background: #f5f5f5;
}
.img {
  position: relative;
  width: 24%;
  height: 180px;
}
.act-img {
  width: 100%;
  height: 100%;
}
.user-price {
  position: absolute;
  z-index: 30;
  bottom: 14px;
  right: 16px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  padding: 4px 12px;
}
.user-right {
  width: 76%;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}
.act-title {
  font-weight: bold;
}
.userdescribe {
  margin-top: 20px;
  line-height: 24px;
  height: 48px;
  color: #999999;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bottom-infos {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
}
.icon-one {
  color: #b0b0b0;
  margin-right: 10px;
}
.icon-two {
  color: #b0b0b0;
}
.mores {
  color: #007940;
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  /*margin-top: 8px;*/
  margin: 8px auto 0 auto;
  position: relative;
  width: 800px;
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #007741;
  color: #fff;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  background: #05a35c;
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  cursor: pointer;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 30px;
  padding: 0 80px;
  box-sizing: border-box;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
</style>



// WEBPACK FOOTER //
// src/components/Introductionview/introductionList.vue